/* ===========================
   Stormie Header — JavaScript
   =========================== */
 
(function () {
  'use strict';
 
  const header       = document.getElementById('stormie-header');
  const hamburgerBtn = document.getElementById('hamburgerBtn');
  const mobileDrawer = document.getElementById('mobileDrawer');
  const drawerOverlay= document.getElementById('drawerOverlay');
  const drawerClose  = document.getElementById('drawerClose');
  const searchToggle = document.getElementById('searchToggle');
  const searchBar    = document.getElementById('searchBar');
  const searchClose  = document.getElementById('searchClose');
  const searchInput  = document.getElementById('searchInput');
  const cartCount    = document.getElementById('cartCount');
 
  if (!header) return;
 
  /* ---- Sticky Header ---- */
  if (header.classList.contains('is-sticky')) {
    let lastScroll = 0;
    window.addEventListener('scroll', function () {
      const currentScroll = window.scrollY;
      if (currentScroll > 80) {
        header.style.boxShadow = '0 2px 12px rgba(0,0,0,0.07)';
      } else {
        header.style.boxShadow = '';
      }
      lastScroll = currentScroll;
    }, { passive: true });
  }
 
  /* ---- Mobile Drawer ---- */
  function openDrawer() {
    mobileDrawer.classList.add('is-open');
    drawerOverlay.classList.add('is-visible');
    hamburgerBtn.classList.add('is-active');
    hamburgerBtn.setAttribute('aria-expanded', 'true');
    mobileDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    drawerClose.focus();
  }
 
  function closeDrawer() {
    mobileDrawer.classList.remove('is-open');
    drawerOverlay.classList.remove('is-visible');
    hamburgerBtn.classList.remove('is-active');
    hamburgerBtn.setAttribute('aria-expanded', 'false');
    mobileDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    hamburgerBtn.focus();
  }
 
  if (hamburgerBtn) {
    hamburgerBtn.addEventListener('click', function () {
      if (mobileDrawer.classList.contains('is-open')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });
  }
 
  if (drawerClose) {
    drawerClose.addEventListener('click', closeDrawer);
  }
 
  if (drawerOverlay) {
    drawerOverlay.addEventListener('click', closeDrawer);
  }
 
  /* Close drawer on ESC */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (mobileDrawer && mobileDrawer.classList.contains('is-open')) closeDrawer();
      if (searchBar && searchBar.classList.contains('is-open')) closeSearch();
    }
  });
 
  /* ---- Mobile Submenu Toggles ---- */
  const mobileToggles = document.querySelectorAll('.mobile-nav-toggle');
  mobileToggles.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      const submenu = this.nextElementSibling;
      const isOpen  = submenu.classList.contains('is-open');
 
      // Close all submenus first
      document.querySelectorAll('.mobile-submenu.is-open').forEach(function (s) {
        s.classList.remove('is-open');
      });
      document.querySelectorAll('.mobile-nav-toggle.is-active').forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-expanded', 'false');
      });
 
      if (!isOpen) {
        submenu.classList.add('is-open');
        this.classList.add('is-active');
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });
 
  /* ---- Search Bar ---- */
  function openSearch() {
    searchBar.classList.add('is-open');
    searchBar.setAttribute('aria-hidden', 'false');
    setTimeout(function () {
      if (searchInput) searchInput.focus();
    }, 260);
  }
 
  function closeSearch() {
    searchBar.classList.remove('is-open');
    searchBar.setAttribute('aria-hidden', 'true');
    if (searchToggle) searchToggle.focus();
  }
 
  if (searchToggle) {
    searchToggle.addEventListener('click', function () {
      if (searchBar.classList.contains('is-open')) {
        closeSearch();
      } else {
        openSearch();
      }
    });
  }
 
  if (searchClose) {
    searchClose.addEventListener('click', closeSearch);
  }
 
  /* ---- Cart Count Update via Shopify AJAX ---- */
  function updateCartCount() {
    if (!cartCount) return;
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        const count = cart.item_count || 0;
        cartCount.textContent = count > 0 ? count : '';
        cartCount.style.display = count > 0 ? '' : 'none';
      })
      .catch(function () {});
  }
 
  /* Update cart count when Shopify cart changes */
  document.addEventListener('cart:updated', updateCartCount);
 
  /* Initial count is rendered server-side, just ensure badge visibility */
  if (cartCount) {
    const count = parseInt(cartCount.textContent, 10) || 0;
    cartCount.style.display = count > 0 ? '' : 'none';
  }
 
})();